import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const EsignRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const success = params.get("success");
    const docId = params.get("docId");
    const message = params.get("message");

    if (success === "true") {
      navigate("/journey/EsignSanctionLetter", {
        replace: true,
        state: { docId },
      });
    } else {
      navigate("/journey/SanctionLetter", {
        replace: true,
        state: {
          esignError: message || "E-sign failed",
        },
      });
    }
  }, [location, navigate]);

  return <div>Redirecting...</div>;
};

export default EsignRedirect;